  import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { Router } from '@angular/router';
import swal from 'sweetalert2';        


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  public loading = false;
  model:any={};

  constructor(
    public authService: AuthService,
    public router: Router
  ) { }
  cert:boolean=false;
  ngOnInit() {
    //this._cert();
    localStorage.clear();
  }
  _cert(){
    let data={};
    this.authService.service("/pba",data).then(
      data => {
        this.cert=false;        
      },
      error => {
        console.log(error);
        this.cert=true;
      });
  }
  fn_recupera_contra(){

  }
  login()
  {
    if (this.model.username ==  "" || this.model.username == null)
    {
      swal.fire('Proporcione el usuario', '', 'error');
      return;
    }
    if (this.model.password ==  "" || this.model.password == null)
    {
      swal.fire('Proporcione el password', '', 'error');
      return;
    }
    let data={
      login:this.model.username,
      password:this.model.password
    };
    this.authService.service("/api/get_login",data).then(
      data => {
        console.log(data)
        this.loading = false;            
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);              

        if (res.length!=0)
        {
          this.loading =false;            
          
          //console.log( "login:");
          console.log( res[0]);
          localStorage.setItem('dia_hoy', res[0].dia);
          localStorage.setItem('mes_hoy', res[0].mes);
          localStorage.setItem('anio_hoy', res[0].anio);
          localStorage.setItem('nombre', res[0].nombre);
          localStorage.setItem('asesor', res[0].asesor);
          localStorage.setItem('preventa', res[0].preventa);
          localStorage.setItem('clientes', res[0].clientes);
          localStorage.setItem('cliente', res[0].cliente);
          localStorage.setItem('hk', res[0].hk);
          localStorage.setItem('facturas', res[0].facturas);
          localStorage.setItem('usuario', res[0].id);
          localStorage.setItem('usuario_role', res[0].id_role);
          localStorage.setItem('usuario_persona', res[0].id_persona);
          localStorage.setItem('foto', res[0].foto);
          localStorage.setItem('sufijo', res[0].sufijo);
          localStorage.setItem('id_role_usu', res[0].id_role);
          //return;
          if(res[0].id_cliente==17){
            localStorage.setItem('garoce',"1");
          }else{
            localStorage.setItem('garoce',"0");
            
          }          
          //this.router.navigate(['/lista_cliente_leady']);
          //this.router.navigate(['/raci2']);
          this.router.navigate(['/cliente']);
          
        }
        else
        {
          swal.fire('Usuario o password incorrectos', '', 'error');
        }
      },
      error => {
          this.loading = false;
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
          swal.fire('¡ERROR API!', '', 'error');
      });  
  }

}
